// export.ts — CSV export of the show ledger (all local; nothing leaves the device).

import type { Show } from "./store";
import { formatMoney } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full CSV: Date, Artists, Venue, City, Cost, Currency, With, Rating, Festival, Setlist notes. */
export function showsCsv(shows: Show[]): string {
  return csv(
    ["Date", "Artists", "Venue", "City", "Cost", "Currency", "With", "Rating", "Festival", "Setlist notes"],
    shows.map((s) => [
      s.seen_on,
      s.artists.join("; "),
      s.venue ?? "",
      s.city ?? "",
      s.cost !== null ? formatMoney(s.cost, s.currency) : "",
      s.currency,
      s.companions.join("; "),
      s.rating > 0 ? String(s.rating) : "",
      s.is_festival ? "yes" : "",
      s.setlist_notes ?? "",
    ]),
  );
}

export function buildExport(shows: Show[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: showsCsv(shows), filename: `encore-shows-${stamp}.csv` };
}
